/**
 * Минимальный ZIP-упаковщик.
 *
 * Файл .xlsx — это ZIP-архив с набором XML внутри, и чтобы собрать его в
 * браузере, нужен упаковщик. Готового в проекте нет: JSZip не установлен, а
 * ставить пакеты с npm у нас нельзя без отдельного разрешения владельца.
 * Своих требований у xlsx к архиву немного, поэтому хватает восьмидесяти
 * строк.
 *
 * Сжатия нет — записи кладутся методом «store». Excel такие архивы читает
 * без оговорок, а отчёт на несколько сотен строк весит десятки килобайт:
 * тянуть ради них реализацию deflate незачем.
 */
/** Таблица CRC-32 (полином 0xEDB88320) — считается один раз при загрузке. */
const CRC_TABLE = (() => {
    const table = new Uint32Array(256);
    for (let i = 0; i < 256; i++) {
        let c = i;
        for (let k = 0; k < 8; k++)
            c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        table[i] = c >>> 0;
    }
    return table;
})();
const crc32 = (bytes) => {
    let c = 0xffffffff;
    for (let i = 0; i < bytes.length; i++)
        c = CRC_TABLE[(c ^ bytes[i]) & 0xff] ^ (c >>> 8);
    return (c ^ 0xffffffff) >>> 0;
};
/** Запись чисел в буфер — ZIP хранит их младшим байтом вперёд. */
const u16 = (v) => [v & 0xff, (v >>> 8) & 0xff];
const u32 = (v) => [v & 0xff, (v >>> 8) & 0xff, (v >>> 16) & 0xff, (v >>> 24) & 0xff];
/**
 * Дата и время в формате MS-DOS — так их хранит ZIP.
 *
 * Секунды пишутся с точностью до двух: в формате на них отведено пять бит.
 */
const dosStamp = (d) => ({
    time: ((d.getHours() & 31) << 11) | ((d.getMinutes() & 63) << 5) | ((d.getSeconds() / 2) & 31),
    date: (((d.getFullYear() - 1980) & 127) << 9) | (((d.getMonth() + 1) & 15) << 5) | (d.getDate() & 31)
});
export const zip = (entries) => {
    const encoder = new TextEncoder();
    const { time, date } = dosStamp(new Date());
    const local = [];
    const central = [];
    let offset = 0;
    for (const entry of entries) {
        const name = encoder.encode(entry.name);
        const data = encoder.encode(entry.content);
        const sum = crc32(data);
        /* Локальный заголовок. Флаг 0x0800 говорит, что имя в UTF-8 —
           без него кириллица в путях читалась бы как попало. */
        const header = [
            ...u32(0x04034b50),
            ...u16(20),
            ...u16(0x0800),
            ...u16(0),
            ...u16(time),
            ...u16(date),
            ...u32(sum),
            ...u32(data.length),
            ...u32(data.length),
            ...u16(name.length),
            ...u16(0)
        ];
        local.push(...header, ...name, ...data);
        central.push(...u32(0x02014b50), ...u16(20), // версия создавшей программы
        ...u16(20), ...u16(0x0800), ...u16(0), ...u16(time), ...u16(date), ...u32(sum), ...u32(data.length), ...u32(data.length), ...u16(name.length), ...u16(0), // длина поля extra
        ...u16(0), // длина комментария
        ...u16(0), // номер диска
        ...u16(0), // внутренние атрибуты
        ...u32(0), // внешние атрибуты
        ...u32(offset), ...name);
        offset += header.length + name.length + data.length;
    }
    const end = [
        ...u32(0x06054b50),
        ...u16(0),
        ...u16(0),
        ...u16(entries.length),
        ...u16(entries.length),
        ...u32(central.length),
        ...u32(offset),
        ...u16(0)
    ];
    return Uint8Array.from([...local, ...central, ...end]);
};
